export default __webpack_public_path__ + "static/media/100_19512.a50d8d0d.jpg";